module.exports = __webpack_public_path__ + "static/img/img3_desktop@2x.81ba41b.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/img3_desktop@2x.png
// module id = ipF9
// module chunks = 1